import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpErrorHandler } from "src/app/shared/services/handle-error.service";
import { retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { RNTFuncionarioEntry } from "src/app/shared/entrys/rnt-funcionario.entry";
import { VehiculoEntry } from "src/app/shared/entrys/vehiculo.entry";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class DetalleDocumentosService
  implements RequestCRUD<RNTFuncionarioEntry, ResponseServiceModel>
{
  private API_URL;
  private Url: string;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  getDocumentos(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/DocumentoDetalleSolicitud/GetParaFuncionario`,
        entry
      )
      .pipe(retry(2));
  }

  getDetalleTurismo(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/DetalleSolicitudTipoTurismoAventura/GetParaFuncionario`,
        entry
      )
      .pipe(retry(2));
  }

  getCamposAdicionales(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/DetalleSolicitudDatosAdicionales/GetParaFuncionario`,
        entry
      )
      .pipe(retry(2));
  }

  getVehiculos(entry: VehiculoEntry): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Vehiculo/GetParaFuncionario`,
        entry
      )
      .pipe(retry(2));
  }

  // getCapacidadOperativa(entry: any): Observable<ResponseServiceModel> {
  // 	return this.http.post<ResponseServiceModel>
  // 		(`${this.API_URL}/CapacidadOperativa/GetParaFuncionario`, entry).pipe(
  // 			retry(2)
  // 		);
  // }

  update(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  create(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  ActualizarDoc343(entry: any): Observable<ResponseServiceModel> {
    this.Url = `${this.API_URL}/DocumentoDetalleSolicitud/ActualizarDoc343`;
    return this.http.post<ResponseServiceModel>(this.Url, entry);
  }
}
